/* THE ATMOSPHERE — snippets/nhp-atmosphere.liquid. Deferred.
   4 · THE STORM: heat lightning in bursts (2–4 strikes, then 40–90s of quiet), each with its own distance and
       side, the sky lit from behind and the page's own glows/fog/posters answering (only while the tab is visible).
   5 · "something in the fog": once per session, after 7s without input it slowly appears at one edge
       of the frame; the instant you scroll/touch/type it's gone, for good. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;

  /* THE STORM — bursts, not a metronome. A burst is 2–4 strikes a second or two apart; then it goes quiet for
     40–90s. Each strike picks its own distance (near = the double snap, far = a slow bloom) and its own side of
     the horizon, and tells the page to react (root.nhp-strike + --si) so the glows, fog and posters answer it. */
  var flash = document.querySelector('[data-nhp-flash]');
  if (flash) {
    /* ?storm=1 — test mode: a burst every few seconds, mostly close strikes, so the storm can be judged
       without waiting for the weather. Never on without the parameter. */
    var testing = /[?&]storm=1/.test(location.search);
    var clearStrike;
    var strike = function () {
      if ((document.hidden && !testing) || root.classList.contains('nhp-ident-on')) return;
      var near = testing ? Math.random() < 0.8 : Math.random() < 0.45;
      var si = near ? 0.8 + Math.random() * 0.2 : 0.45 + Math.random() * 0.35;
      root.style.setProperty('--si', si.toFixed(2));
      flash.style.setProperty('--sx', (8 + Math.random() * 84).toFixed(0) + '%');
      flash.classList.remove('is-on', 'is-near');
      void flash.offsetWidth;
      flash.classList.add('is-on');
      if (near) flash.classList.add('is-near');
      root.classList.add('nhp-strike');
      clearTimeout(clearStrike);
      clearStrike = setTimeout(function () { root.classList.remove('nhp-strike'); }, near ? 420 : 300);
    };

    var burst = function () {
      var hits = 2 + Math.floor(Math.random() * 3);   // 2–4
      var at = 0;
      for (var i = 0; i < hits; i++) {
        setTimeout(strike, at);
        at += 600 + Math.random() * 1600;             // never two inside 300ms (the flash limit)
      }
      setTimeout(burst, testing ? at + 2500 : at + 18000 + Math.random() * 17000);
    };
    setTimeout(burst, testing ? 600 : 2500 + Math.random() * 2500);
  }

  var watcher = document.querySelector('[data-nhp-watcher]');
  var seen = false;
  try { seen = sessionStorage.getItem('nhpWatcher') === '1'; } catch (e) {}
  if (!watcher || seen) return;

  var IDLE_MS = 7000;
  var idle = null;
  var showing = false;
  var done = false;
  // User input only. Page scroll is listened for WITHOUT capture: with capture, element scrolls count too,
  // and the old homepage carousels auto-scroll every few seconds, so the figure never got its quiet 7s.
  var inputs = ['wheel', 'touchstart', 'pointerdown', 'keydown'];

  function arm() {
    clearTimeout(idle);
    if (!done) idle = setTimeout(appear, IDLE_MS);
  }

  function appear() {
    if (done || document.hidden || root.classList.contains('nhp-ident-on')) return arm();
    if (Math.random() < 0.5) watcher.classList.add('is-left');
    watcher.classList.add('is-there');
    showing = true;
    try { sessionStorage.setItem('nhpWatcher', '1'); } catch (e) {}
  }

  function onInput() {
    if (showing) {
      watcher.classList.add('is-gone');
      done = true;
      showing = false;
      inputs.forEach(function (ev) { window.removeEventListener(ev, onInput, true); });
      window.removeEventListener('scroll', onInput);
      return;
    }
    arm();
  }

  inputs.forEach(function (ev) { window.addEventListener(ev, onInput, { capture: true, passive: true }); });
  window.addEventListener('scroll', onInput, { passive: true });
  arm();
})();
